export default function GroupDetailsScreen() {
  return null;
}